export const GET_TRANSACTIONS = "GET_TRANSACTIONS";
export const SET_TRANSACTIONS = "SET_TRANSACTIONS";
export const SET_TABLE_LOADING = "SET_TABLE_LOADING";
